import React, { Fragment } from 'react';
import USBNotification from '@usb-shield/react-notification';

function PageLevelNotification({
    errorNotifications,
    handleErrorClick,
}) {
    const handleLocalErrorClick = (e, id) => {
        e.preventDefault();
        const ele =
            document.getElementById(`component-${id}`) ||
            document.getElementById('wrapper_business-name');
        ele?.scrollIntoView();
        handleErrorClick();
    };
    return (
        <>
            {errorNotifications.length > 0 && (
                <div className="form-field-wrapper error-notification">
                    <USBNotification
                        addClasses="validation-error"
                        iconAssistiveText={{ label: ' ' }}
                        variant="error"
                        roleType="alert"
                        id="inviteFormErrors"
                        notificationData={errorNotifications}
                        multipleNotificationMessage="The following items need your attention:"
                    >
                        {errorNotifications.length > 1 && (
                            <h3 className="notification-header">
                                The following items need your
                                attention:
                            </h3>
                        )}
                        {errorNotifications.length > 1 &&
                            errorNotifications.map((value, index) => (
                                <ul
                                    className="error-list"
                                    key={value.linkText}
                                >
                                    <li>
                                        <span className="multiple-notification--text">
                                            {`${value.text} `}
                                        </span>
                                        <a
                                            aria-labelledby={`inner-link${
                                                index + 1
                                            }`}
                                            onClick={(e) =>
                                                handleLocalErrorClick(
                                                    e,
                                                    value.id,
                                                )
                                            }
                                            href={value.id}
                                        >
                                            <span
                                                className="multiple-notification--btn-text"
                                                id={`inner-link${
                                                    index + 1
                                                }`} // JAWS page level error A11Y issue fix
                                                tabIndex="-1"
                                            >
                                                {value.linkText}
                                            </span>
                                        </a>
                                        .
                                    </li>
                                </ul>
                            ))}
                        {errorNotifications.length === 1 &&
                            errorNotifications.map((item, index) => (
                                <Fragment
                                    key={`${item.id}_single-notification-msg`}
                                >
                                    <span className="multiple-notification--text">{`${item?.text} `}</span>
                                    <a
                                        aria-labelledby={`inner-link${
                                            index + 1
                                        }`}
                                        onClick={(e) =>
                                            handleLocalErrorClick(
                                                e,
                                                item.id,
                                            )
                                        }
                                        href={item.id || '#'}
                                    >
                                        <span className="multiple-notification--btn-text">
                                            {item?.linkText}
                                        </span>
                                    </a>
                                    .
                                </Fragment>
                            ))}
                    </USBNotification>
                </div>
            )}
        </>
    );
}

export default PageLevelNotification;
